export const stringFromParams = params => {
  let str = ''

  if (params.page) {
    str += `${params.page}_`
  }

  if (params.group_by.length) {
    params.group_by.forEach((item, index) => {
      str += `${item}`

      if (index !== params.group_by.length - 1) {
        str += '_'
      }
    })
  }

  return str
}
